var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaJpegIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minerva_jpeg_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.951,
    height: 90.026,
    viewBox: "0 0 78.951 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139267",
    "data-name": "\\uD328\\uC2A4 139267",
    d: "M64.912,85.795H1.821A1.821,1.821,0,0,1,0,83.974V1.821A1.821,1.821,0,0,1,1.821,0H64.912a1.821,1.821,0,0,1,1.821,1.821V83.974A1.821,1.821,0,0,1,64.912,85.795Z",
    transform: "translate(12.218 4.231)",
    fill: "#939598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139268",
    "data-name": "\\uD328\\uC2A4 139268",
    d: "M43.376,0H1.821A1.821,1.821,0,0,0,0,1.821V83.974A1.821,1.821,0,0,0,1.821,85.8H64.912a1.821,1.821,0,0,0,1.821-1.821V22.6Z",
    transform: "translate(7.985 0)",
    fill: "#f1f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139269",
    "data-name": "\\uD328\\uC2A4 139269",
    d: "M.91,75.808A.913.913,0,0,1,0,74.9V.91A.922.922,0,0,1,.269.269.9.9,0,0,1,.91,0H27.076a.91.91,0,0,1,0,1.821H1.821V74.9A.91.91,0,0,1,.91,75.808ZM30.719,1.821a.91.91,0,1,1,.91-.91A.91.91,0,0,1,30.719,1.821Z",
    transform: "translate(9.805 1.82)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139270",
    "data-name": "\\uD328\\uC2A4 139270",
    d: "M62.181,0V61.225a1.821,1.821,0,0,1-1.821,1.821H0v2.731A1.821,1.821,0,0,0,1.821,67.6H64.912a1.821,1.821,0,0,0,1.821-1.821V4.405Z",
    transform: "translate(7.985 18.197)",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139271",
    "data-name": "\\uD328\\uC2A4 139271",
    d: "M64.457,0V61.3a1.821,1.821,0,0,1-1.821,1.821H0v.455A1.821,1.821,0,0,0,1.821,65.4H64.912a1.821,1.821,0,0,0,1.821-1.821V2.2Z",
    transform: "translate(7.985 20.4)",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139272",
    "data-name": "\\uD328\\uC2A4 139272",
    d: "M0,20.9A1.707,1.707,0,0,0,1.707,22.6H23.358L0,0Z",
    transform: "translate(51.362)",
    fill: "#d1d3d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139273",
    "data-name": "\\uD328\\uC2A4 139273",
    d: "M43,16.255H1.821A1.821,1.821,0,0,1,0,14.434V1.821A1.821,1.821,0,0,1,1.821,0H43a1.821,1.821,0,0,1,1.821,1.821V14.434A1.821,1.821,0,0,1,43,16.255Z",
    transform: "translate(0 6.347)",
    fill: "#2266d3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139279",
    "data-name": "\\uD328\\uC2A4 139279",
    d: "M43.975,28.321H2.988A2.988,2.988,0,0,1,0,25.333V2.988A2.988,2.988,0,0,1,2.988,0H43.975a2.988,2.988,0,0,1,2.988,2.988V25.333A2.988,2.988,0,0,1,43.975,28.321Z",
    transform: "translate(17.926 36.029)",
    fill: "#5e9cf7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139280",
    "data-name": "\\uD328\\uC2A4 139280",
    d: "M6.2.322.138,8.957a.756.756,0,0,0,.619,1.19H12.873a.756.756,0,0,0,.619-1.19L7.434.322A.756.756,0,0,0,6.2.322Z",
    transform: "translate(23.033 49.426)",
    fill: "#2266d3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139281",
    "data-name": "\\uD328\\uC2A4 139281",
    d: "M11.718.322.138,16.829a.756.756,0,0,0,.619,1.19h23.16a.756.756,0,0,0,.619-1.19L12.956.322A.756.756,0,0,0,11.718.322Z",
    transform: "translate(35.108 41.555)",
    fill: "#2266d3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139379",
    "data-name": "\\uD328\\uC2A4 139379",
    d: "M3.021,0A3.021,3.021,0,1,1,0,3.021,3.021,3.021,0,0,1,3.021,0Z",
    transform: "translate(26.826 40.994)",
    fill: "#2266d3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139380",
    "data-name": "\\uD328\\uC2A4 139380",
    d: "M5.953,7.635a2.827,2.827,0,0,1-.972,2.274,4.063,4.063,0,0,1-2.715.827A11.67,11.67,0,0,1,0,10.515V8.682H.193A4.8,4.8,0,0,0,1.8,9.034a2.741,2.741,0,0,0,1.058-.176,1.2,1.2,0,0,0,.62-.568,4.432,4.432,0,0,0,.2-1.7V1.854H1.364V.2H5.953ZM10.7,7.049v3.535H8.431V.2h3.928a4.884,4.884,0,0,1,3.066.823,2.879,2.879,0,0,1,1.047,2.408,3.28,3.28,0,0,1-1.158,2.636,4.505,4.505,0,0,1-3.018.982Zm-.014-5.216V5.4H11.3a3.736,3.736,0,0,0,2.264-.472,1.8,1.8,0,0,0,.555-1.45,1.467,1.467,0,0,0-.534-1.227,3.668,3.668,0,0,0-2.112-.42Zm14.8,8.751H18.26V.2h7.235V1.922H20.52V4.141h4.624V5.857H20.52v3h4.975Zm10.89-.641a10.406,10.406,0,0,1-3.948.861A5.5,5.5,0,0,1,28.41,9.378a5.351,5.351,0,0,1-1.45-4,5.245,5.245,0,0,1,1.485-3.928A5.537,5.537,0,0,1,32.492,0a8.97,8.97,0,0,1,3.866.916V3.025h-.241a7.414,7.414,0,0,0-1.991-1.154,4.918,4.918,0,0,0-1.488-.245,3.061,3.061,0,0,0-2.4.989A3.939,3.939,0,0,0,29.35,5.34a4.1,4.1,0,0,0,.913,2.877,3.428,3.428,0,0,0,2.649.989,4.353,4.353,0,0,0,1.247-.172V6.67H31.838V5.016h4.548Z",
    transform: "translate(4.147 9.083)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaJpegIcon);
export default __webpack_public_path__ + "static/media/minerva_jpeg_icon.8818d099cbb7c10eb0c208f30c42d609.svg";
export { ForwardRef as ReactComponent };